import { render, staticRenderFns } from "./ShortAnswerQuestion.vue?vue&type=template&id=991de808&scoped=true&"
import script from "./ShortAnswerQuestion.vue?vue&type=script&lang=js&"
export * from "./ShortAnswerQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ShortAnswerQuestion.vue?vue&type=style&index=0&id=991de808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991de808",
  null
  
)

export default component.exports